
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.2127',
  depVersions: {
  "customer-portal-app": "static-1.2127",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.460",
  "data-fetching-client": "static-1.9623",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.428",
  "growth-payments-core": "static-1.25204",
  "head-dlb": "static-1.4938",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5542",
  "hs-test-utils": "static-1.7964",
  "hub-http": "static-1.6170",
  "hub-http-shared-msw-handlers": "static-1.9836",
  "hubspot-dlb": "static-2.1832",
  "hubspot-prosemirror": "static-1.18077",
  "hubspot-url-utils": "static-1.4049",
  "HubStyleTokens": "static-2.11410",
  "I18n": "static-7.1610",
  "immutable": "static-2.77",
  "jasmine-runner": "static-1.6418",
  "payment-link-components": "static-1.23374",
  "prosemirror": "static-1.13",
  "quartz": "static-1.6955",
  "quartz-core": "static-1.6174",
  "react": "static-7.184",
  "react-colorpicker": "static-2.10159",
  "react-dlb": "static-1.77",
  "react-utils": "static-2.5300",
  "rich-text-lib": "static-1.19735",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.17911",
  "ui-components-test-utils": "static-1.5548",
  "UIComponents": "static-3.8357",
  "foundations-assets": "static-1.4805",
  "foundations-components": "static-1.7826",
  "foundations-theming": "static-1.4365",
  "foundations-theming-specialty": "static-1.2081",
  "framer-motion": "static-1.71",
  "metrics-js": "static-1.9542",
  "PortalIdParser": "static-2.388",
  "portals-platform-lib": "static-1.792",
  "quartz-config": "static-1.733",
  "quartz-routing": "static-1.385",
  "quick-fetch": "static-1.3873",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1-feature-id-1324-marker-timings.12",
  "rpc-client-utils": "static-1.4600",
  "sanitize-text": "static-1.8092",
  "styled-components": "static-2.88",
  "tanstack-table": "static-1.54",
  "ui-addon-draggable": "static-3.4719",
  "ui-addon-react-router-dom": "static-1.9494",
  "usage-tracker": "static-1.7287",
  "usage-tracker-anonymous": "static-1.5704",
  "usage-tracker-core": "static-1.7137",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5489",
  "raven": "static-3.5829",
  "raven-hubspot": "static-1.6136",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.70",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3360",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3232",
  "quartz-webpack": "static-1.3179",
  "bend-plugin-quartz-routing": "static-1.33",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.81",
  "customer-data-objects": "static-1.7610",
  "frontend-preferences-client": "static-1.7876",
  "laboratory-lib": "static-3.7107",
  "onboarding-scopes": "static-1.6411",
  "ui-addon-opt": "static-4.8322",
  "HeadJS": "static-2.740",
  "hs-test-utils-bend-plugin": "static-1.3075",
  "msw": "static-1.39",
  "testing-library": "static-1.151",
  "hs-locale-management": "static-1.40",
  "ts-schema": "static-1.4035",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7669",
  "cssUtils": "static-1.778",
  "customer-data-ui-utilities": "static-1.9775",
  "HubStyle": "static-2.11718",
  "knowledge-content-types": "static-1.8479",
  "PatternValidationJS": "static-1.437",
  "quartz-i18n": "static-1.630",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.486",
  "ui-addon-emoji-picker": "static-1.9836",
  "ui-addon-i18n": "static-1.11099",
  "ui-business-units-lib": "static-1.8996",
  "ui-shepherd-react": "static-3.10097",
  "video-components-external": "static-1.11089",
  "i18n-data": "static-1.220",
  "moment-timezone": "static-5.82",
  "jasmine": "static-4.4273",
  "commerce-tours-lib": "static-1.5993",
  "customer-data-properties": "static-1.51356",
  "getting-started-shared-tasks": "static-1.18340",
  "growth-onboarding-reliability": "static-1.5030",
  "onboarding-tours": "static-1.16495",
  "reference-resolvers-lite": "static-1.8043",
  "sales-checkout-service-client": "static-1.3588",
  "ui-addon-iframeable": "static-1.9001",
  "user-context": "static-1.5050",
  "dispatcher": "static-1.135",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.826",
  "hubspotter-http": "static-1.4609",
  "icons": "static-2.643",
  "mobile-manifest-mixins": "static-1.514",
  "module-federation": "static-1.22",
  "quartz-auth": "static-1.630",
  "quartz-head": "static-1.620",
  "quartz-test": "static-1.630",
  "quartz-tracking": "static-1.334",
  "ui-fonts": "static-1.672",
  "usage-tracker-container": "static-1.7277",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9377",
  "data-token-picker": "static-1.16308",
  "FileManagerLib": "static-1.39101",
  "property-translator": "static-1.5352",
  "atom": "static-1.5021",
  "merchandise-lib": "static-1.262",
  "purchase-motions-components": "static-1.5786",
  "salesImages": "static-1.524",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5309",
  "react-select-plus": "static-1.104",
  "react-virtualized": "static-2.98",
  "ui-images": "static-2.1138",
  "bend-plugin-foundations-components": "static-1.4095",
  "floating-ui": "static-1.55",
  "react-aria": "static-1.65",
  "react-create-root-preference": "static-1.9",
  "trellis-assets": "static-1.1661",
  "bend-plugin-foundations-theming": "static-1.2848",
  "foundations-theming-base": "static-1.3350",
  "stylex": "static-1.32",
  "interframe": "static-3.4710",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5701",
  "history": "static-4.47",
  "react-router-dom": "static-5.26",
  "web-vitals": "static-1.4",
  "bend-plugin-chirp-manifest": "static-1.10",
  "chirp-fetch": "static-1.1834",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4421",
  "react-flip-move": "static-1.69",
  "bender-build-tools": "static-1.3123",
  "inbound-db-properties-service-client": "static-1.3797",
  "superstore": "static-1.4715",
  "feedback-loader": "static-1.29197",
  "ai-components-ui-library": "static-1.8794",
  "ui-addon-video-player": "static-1.8647",
  "ui-coaching-tips": "static-1.28389",
  "sassPrefix": "static-1.155",
  "react-dnd-compat": "static-1.4569",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2446",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8119",
  "reselect": "static-2.16",
  "apollo-link-hub-http": "static-2.4597",
  "content-media-composition-data-lib": "static-1.12065",
  "content-media-compositions": "static-2.16072",
  "idb-keyval": "static-1.43",
  "immer": "static-1.33",
  "immerable": "static-1.4102",
  "magpie-lib": "static-1.5526",
  "magpie-types": "static-1.4986",
  "media-bridge-lib": "static-1.18831",
  "video-data-lib": "static-1.34747",
  "commerce-products-lib": "static-1.9324",
  "crm-message-bus": "static-1.42836",
  "growth-data-modal": "static-1.5342",
  "hubspot-apollo-client": "static-1.4825",
  "onboarding-tours-client": "static-1.4709",
  "calling-global-api": "static-1.64315",
  "calling-internal-common": "static-1.31250",
  "calling-lifecycle-internal": "static-1.65697",
  "calling-lifecycle-messages": "static-1.57991",
  "conditional-properties-service-client": "static-1.3753",
  "crm-links": "static-1.6230",
  "customer-data-objects-ui-components": "static-1.12973",
  "customer-data-properties-shared-msw-handlers": "static-1.9163",
  "customer-data-property-utils": "static-1.8032",
  "external-options-client-types": "static-1.4115",
  "file-manager-components": "static-1.23461",
  "framework-data-schema-resolvers": "static-1.6827",
  "google-libphonenumber": "static-1.37",
  "hs-resources": "static-1.93",
  "inbound-db-meta-service-client": "static-1.3547",
  "inbounddb-objects-service-types": "static-1.4180",
  "meetings-icalendar-utils-lib": "static-1.580",
  "multi-currency-client-types": "static-1.3648",
  "object-builder-ui-client": "static-1.48551",
  "pipeline-validation-client-types": "static-1.3922",
  "property-value-citations": "static-1.1970",
  "pulse": "static-1.504",
  "smart-property-lib": "static-1.6666",
  "tiered-pricing": "static-1.1095",
  "ui-addon-form-validation": "static-1.10937",
  "growth-onboarding-confetti": "static-1.3016",
  "growth-onboarding-next-action-utils": "static-1.1752",
  "navigation-components": "static-1.17840",
  "onboarding-tours-utils": "static-1.561",
  "ui-shepherd-tracker": "static-1.7478",
  "ui-universal-auth": "static-1.8910",
  "batch-promise": "static-1.1499",
  "navigation-messaging": "static-1.7167",
  "getting-started-shared-tasks-store": "static-1.17458",
  "hubspotter-http-shared-msw-handlers": "static-1.9834",
  "usage-tracker-session-replay": "static-1.4973",
  "audio-components": "static-1.5834",
  "FileManagerCore": "static-1.38960",
  "FileManagerImages": "static-1.36612",
  "video-components": "static-1.13092",
  "foundations-components-legacy": "static-1.851",
  "purchase-motions-api": "static-1.5789",
  "self-service-api": "static-1.10194",
  "signup-constants": "static-1.18740",
  "signup-ui-url-generator": "static-2.7987",
  "trials-service-types": "static-1.3852",
  "usage-tracker-public": "static-1.7098",
  "chatspot-core": "static-1.21022",
  "ContentUtils": "static-1.68200",
  "copilot-toolkit": "static-1.10969",
  "growth-onboarding-feedback-components": "static-1.6532",
  "reactive-lib": "static-1.670",
  "simple-logging-lib": "static-1.2998",
  "commerce-permissions": "static-1.714",
  "customer-data-tracking": "static-1.6834",
  "products-iframe-lib": "static-1.7766",
  "products-ui-components-shared-msw-handlers": "static-1.10218",
  "onboarding-data-sync-lib": "static-1.1871",
  "hubspot-apollo-cache": "static-1.284",
  "calling-error-reporting": "static-1.31256",
  "shared-worker-versioning": "static-1.10986",
  "calling-usage-tracker": "static-1.6491",
  "voice-sms-access-library": "static-1.761",
  "conversations-skeleton-state": "static-1.7197",
  "location-customization-utils-lib": "static-1.9079",
  "crm-pipelines-api-client-types": "static-1.4099",
  "framework-builder-read-service-client": "static-1.3966",
  "framework-data-schema-quick-fetch": "static-1.6732",
  "persist-promise": "static-1.3656",
  "bend-plugin-pulse": "static-1.7",
  "directed-graph": "static-1.884",
  "event-emitter": "static-1.897",
  "fast-json-patch": "static-1.62",
  "data-agent-kit": "static-1.108",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9919",
  "fsm": "static-1.3681",
  "policy-lib": "static-1.6721",
  "react-tinymce": "static-1.55084",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9982",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54210",
  "tinymce-plugins": "static-1.57324",
  "tinymce-themes": "static-1.56180",
  "growth-onboarding-next-action-components": "static-1.1780",
  "user-context-client": "static-1.4559",
  "nest": "static-1.174",
  "unified-auth-core-lib": "static-1.705",
  "amplitude-session-replay-browser": "static-1.59",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4480",
  "video-embed": "static-1.35581",
  "content-icons-ui": "static-1.2211",
  "social-insights-client-types": "static-1.21930",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4760",
  "integrations-lib": "static-1.15941",
  "underscore": "static-1.8",
  "sales-views-client-types": "static-1.4213",
  "InboxConnectUtils": "static-4.14645",
  "calling-orchestration-schema": "static-1.35538",
  "crm-record-cards-service-types": "static-1.3568",
  "highcharts": "static-8.103",
  "trellis-story-utils": "static-1.4464",
  "storybook-react": "static-1.32",
  "hub-http-contrib": "static-1.2989",
  "tinymce-data": "static-1.40295",
  "ui-addon-sales-email": "static-1.5159",
  "codemirror": "static-5.94",
  "layout-dnd-components": "static-1.12338",
  "layout-dnd-utils": "static-1.11313",
  "react-codemirror": "static-1.10572",
  "ui-brand-identity-lib": "static-1.14991",
  "NamespacedHubStyle": "static-2.9019",
  "outpost": "static-1.4138",
  "flux-actions": "static-1.330",
  "integrations-error-boundary-lib": "static-1.13356",
  "integrations-tracking-lib": "static-1.5547",
  "native-integrations-shared-strings": "static-1.7732",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10320",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.424",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68275",
  "layout-data-lib": "static-1.9638",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.2961",
  "google-sheets-integration-lib": "static-1.73",
  "microsoft-drive-integration-lib": "static-1.185",
  "advanced-menus-core": "static-1.15042",
  "advanced-menus-lib": "static-1.11996",
  "ExportDialog": "static-6.10342",
  "ui-memberships-settings-lib": "static-1.33893",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15041",
  "simple-menus-lib": "static-1.16558"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.2127",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.460",
  "data-fetching-client": "/data-fetching-client/static-1.9623",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.428",
  "growth-payments-core": "/growth-payments-core/static-1.25204",
  "head-dlb": "/head-dlb/static-1.4938",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5542",
  "hs-test-utils": "/hs-test-utils/static-1.7964",
  "hub-http": "/hub-http/static-1.6170",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9836",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18077",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyleTokens": "/HubStyleTokens/static-2.11410",
  "I18n": "/I18n/static-7.1610",
  "immutable": "/immutable/static-2.77",
  "jasmine-runner": "/jasmine-runner/static-1.6418",
  "payment-link-components": "/payment-link-components/static-1.23374",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.6955",
  "quartz-core": "/quartz-core/static-1.6174",
  "react": "/react/static-7.184",
  "react-colorpicker": "/react-colorpicker/static-2.10159",
  "react-dlb": "/react-dlb/static-1.77",
  "react-utils": "/react-utils/static-2.5300",
  "rich-text-lib": "/rich-text-lib/static-1.19735",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17911",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5548",
  "UIComponents": "/UIComponents/static-3.8357",
  "foundations-assets": "/foundations-assets/static-1.4805",
  "foundations-components": "/foundations-components/static-1.7826",
  "foundations-theming": "/foundations-theming/static-1.4365",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2081",
  "framer-motion": "/framer-motion/static-1.71",
  "metrics-js": "/metrics-js/static-1.9542",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "portals-platform-lib": "/portals-platform-lib/static-1.792",
  "quartz-config": "/quartz-config/static-1.733",
  "quartz-routing": "/quartz-routing/static-1.385",
  "quick-fetch": "/quick-fetch/static-1.3873",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1-feature-id-1324-marker-timings.12",
  "rpc-client-utils": "/rpc-client-utils/static-1.4600",
  "sanitize-text": "/sanitize-text/static-1.8092",
  "styled-components": "/styled-components/static-2.88",
  "tanstack-table": "/tanstack-table/static-1.54",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4719",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9494",
  "usage-tracker": "/usage-tracker/static-1.7287",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5704",
  "usage-tracker-core": "/usage-tracker-core/static-1.7137",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "raven": "/raven/static-3.5829",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.70",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3360",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3232",
  "quartz-webpack": "/quartz-webpack/static-1.3179",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.33",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.81",
  "customer-data-objects": "/customer-data-objects/static-1.7610",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7876",
  "laboratory-lib": "/laboratory-lib/static-3.7107",
  "onboarding-scopes": "/onboarding-scopes/static-1.6411",
  "ui-addon-opt": "/ui-addon-opt/static-4.8322",
  "HeadJS": "/HeadJS/static-2.740",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3075",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.151",
  "hs-locale-management": "/hs-locale-management/static-1.40",
  "ts-schema": "/ts-schema/static-1.4035",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7669",
  "cssUtils": "/cssUtils/static-1.778",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9775",
  "HubStyle": "/HubStyle/static-2.11718",
  "knowledge-content-types": "/knowledge-content-types/static-1.8479",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "quartz-i18n": "/quartz-i18n/static-1.630",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.486",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9836",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11099",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8996",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10097",
  "video-components-external": "/video-components-external/static-1.11089",
  "i18n-data": "/i18n-data/static-1.220",
  "moment-timezone": "/moment-timezone/static-5.82",
  "jasmine": "/jasmine/static-4.4273",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5993",
  "customer-data-properties": "/customer-data-properties/static-1.51356",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18340",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5030",
  "onboarding-tours": "/onboarding-tours/static-1.16495",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8043",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3588",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9001",
  "user-context": "/user-context/static-1.5050",
  "dispatcher": "/dispatcher/static-1.135",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.826",
  "hubspotter-http": "/hubspotter-http/static-1.4609",
  "icons": "/icons/static-2.643",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.514",
  "module-federation": "/module-federation/static-1.22",
  "quartz-auth": "/quartz-auth/static-1.630",
  "quartz-head": "/quartz-head/static-1.620",
  "quartz-test": "/quartz-test/static-1.630",
  "quartz-tracking": "/quartz-tracking/static-1.334",
  "ui-fonts": "/ui-fonts/static-1.672",
  "usage-tracker-container": "/usage-tracker-container/static-1.7277",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9377",
  "data-token-picker": "/data-token-picker/static-1.16308",
  "FileManagerLib": "/FileManagerLib/static-1.39101",
  "property-translator": "/property-translator/static-1.5352",
  "atom": "/atom/static-1.5021",
  "merchandise-lib": "/merchandise-lib/static-1.262",
  "purchase-motions-components": "/purchase-motions-components/static-1.5786",
  "salesImages": "/salesImages/static-1.524",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5309",
  "react-select-plus": "/react-select-plus/static-1.104",
  "react-virtualized": "/react-virtualized/static-2.98",
  "ui-images": "/ui-images/static-2.1138",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4095",
  "floating-ui": "/floating-ui/static-1.55",
  "react-aria": "/react-aria/static-1.65",
  "react-create-root-preference": "/react-create-root-preference/static-1.9",
  "trellis-assets": "/trellis-assets/static-1.1661",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2848",
  "foundations-theming-base": "/foundations-theming-base/static-1.3350",
  "stylex": "/stylex/static-1.32",
  "interframe": "/interframe/static-3.4710",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5701",
  "history": "/history/static-4.47",
  "react-router-dom": "/react-router-dom/static-5.26",
  "web-vitals": "/web-vitals/static-1.4",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.10",
  "chirp-fetch": "/chirp-fetch/static-1.1834",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4421",
  "react-flip-move": "/react-flip-move/static-1.69",
  "bender-build-tools": "/bender-build-tools/static-1.3123",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3797",
  "superstore": "/superstore/static-1.4715",
  "feedback-loader": "/feedback-loader/static-1.29197",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8794",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8647",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28389",
  "sassPrefix": "/sassPrefix/static-1.155",
  "react-dnd-compat": "/react-dnd-compat/static-1.4569",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2446",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8119",
  "reselect": "/reselect/static-2.16",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4597",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12065",
  "content-media-compositions": "/content-media-compositions/static-2.16072",
  "idb-keyval": "/idb-keyval/static-1.43",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4102",
  "magpie-lib": "/magpie-lib/static-1.5526",
  "magpie-types": "/magpie-types/static-1.4986",
  "media-bridge-lib": "/media-bridge-lib/static-1.18831",
  "video-data-lib": "/video-data-lib/static-1.34747",
  "commerce-products-lib": "/commerce-products-lib/static-1.9324",
  "crm-message-bus": "/crm-message-bus/static-1.42836",
  "growth-data-modal": "/growth-data-modal/static-1.5342",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4825",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4709",
  "calling-global-api": "/calling-global-api/static-1.64315",
  "calling-internal-common": "/calling-internal-common/static-1.31250",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65697",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57991",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3753",
  "crm-links": "/crm-links/static-1.6230",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12973",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9163",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8032",
  "external-options-client-types": "/external-options-client-types/static-1.4115",
  "file-manager-components": "/file-manager-components/static-1.23461",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6827",
  "google-libphonenumber": "/google-libphonenumber/static-1.37",
  "hs-resources": "/hs-resources/static-1.93",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3547",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4180",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.580",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3648",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48551",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3922",
  "property-value-citations": "/property-value-citations/static-1.1970",
  "pulse": "/pulse/static-1.504",
  "smart-property-lib": "/smart-property-lib/static-1.6666",
  "tiered-pricing": "/tiered-pricing/static-1.1095",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10937",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3016",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1752",
  "navigation-components": "/navigation-components/static-1.17840",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.561",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7478",
  "ui-universal-auth": "/ui-universal-auth/static-1.8910",
  "batch-promise": "/batch-promise/static-1.1499",
  "navigation-messaging": "/navigation-messaging/static-1.7167",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17458",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9834",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4973",
  "audio-components": "/audio-components/static-1.5834",
  "FileManagerCore": "/FileManagerCore/static-1.38960",
  "FileManagerImages": "/FileManagerImages/static-1.36612",
  "video-components": "/video-components/static-1.13092",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.851",
  "purchase-motions-api": "/purchase-motions-api/static-1.5789",
  "self-service-api": "/self-service-api/static-1.10194",
  "signup-constants": "/signup-constants/static-1.18740",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7987",
  "trials-service-types": "/trials-service-types/static-1.3852",
  "usage-tracker-public": "/usage-tracker-public/static-1.7098",
  "chatspot-core": "/chatspot-core/static-1.21022",
  "ContentUtils": "/ContentUtils/static-1.68200",
  "copilot-toolkit": "/copilot-toolkit/static-1.10969",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6532",
  "reactive-lib": "/reactive-lib/static-1.670",
  "simple-logging-lib": "/simple-logging-lib/static-1.2998",
  "commerce-permissions": "/commerce-permissions/static-1.714",
  "customer-data-tracking": "/customer-data-tracking/static-1.6834",
  "products-iframe-lib": "/products-iframe-lib/static-1.7766",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10218",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1871",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.284",
  "calling-error-reporting": "/calling-error-reporting/static-1.31256",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10986",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6491",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.761",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7197",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9079",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4099",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3966",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6732",
  "persist-promise": "/persist-promise/static-1.3656",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.7",
  "directed-graph": "/directed-graph/static-1.884",
  "event-emitter": "/event-emitter/static-1.897",
  "fast-json-patch": "/fast-json-patch/static-1.62",
  "data-agent-kit": "/data-agent-kit/static-1.108",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9919",
  "fsm": "/fsm/static-1.3681",
  "policy-lib": "/policy-lib/static-1.6721",
  "react-tinymce": "/react-tinymce/static-1.55084",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9982",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54210",
  "tinymce-plugins": "/tinymce-plugins/static-1.57324",
  "tinymce-themes": "/tinymce-themes/static-1.56180",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1780",
  "user-context-client": "/user-context-client/static-1.4559",
  "nest": "/nest/static-1.174",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.705",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.59",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4480",
  "video-embed": "/video-embed/static-1.35581",
  "content-icons-ui": "/content-icons-ui/static-1.2211",
  "social-insights-client-types": "/social-insights-client-types/static-1.21930",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4760",
  "integrations-lib": "/integrations-lib/static-1.15941",
  "underscore": "/underscore/static-1.8",
  "sales-views-client-types": "/sales-views-client-types/static-1.4213",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14645",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35538",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3568",
  "highcharts": "/highcharts/static-8.103",
  "trellis-story-utils": "/trellis-story-utils/static-1.4464",
  "storybook-react": "/storybook-react/static-1.32",
  "hub-http-contrib": "/hub-http-contrib/static-1.2989",
  "tinymce-data": "/tinymce-data/static-1.40295",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5159",
  "codemirror": "/codemirror/static-5.94",
  "layout-dnd-components": "/layout-dnd-components/static-1.12338",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11313",
  "react-codemirror": "/react-codemirror/static-1.10572",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14991",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9019",
  "outpost": "/outpost/static-1.4138",
  "flux-actions": "/flux-actions/static-1.330",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13356",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5547",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7732",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10320",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.424",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68275",
  "layout-data-lib": "/layout-data-lib/static-1.9638",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2961",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.73",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.185",
  "advanced-menus-core": "/advanced-menus-core/static-1.15042",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11996",
  "ExportDialog": "/ExportDialog/static-6.10342",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33893",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15041",
  "simple-menus-lib": "/simple-menus-lib/static-1.16558"
}
};
